document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll(
    '[data-hbca-engraving-section]'
  );

  sections.forEach(function (section) {
    // Mobile: zoom the comb once its preview reaches the sticky header position.
    // The preview remains sticky while the description and form scroll beneath it.
    const stickyPreview = section.querySelector('.hbca-engraving-preview');
    if (stickyPreview) {
      let previewFrame = 0;
      function updateDockedPreview() {
        previewFrame = 0;
        if (window.matchMedia('(min-width: 750px)').matches) {
          section.classList.remove('hbca-preview-docked');
          return;
        }
        const top = parseFloat(getComputedStyle(stickyPreview).top) || 60;
        const rect = stickyPreview.getBoundingClientRect();
        const docked = window.scrollY > 40 && rect.top <= top + 3;
        section.classList.toggle('hbca-preview-docked', docked);
      }
      function queueDockedPreview() {
        if (!previewFrame) previewFrame = requestAnimationFrame(updateDockedPreview);
      }
      window.addEventListener('scroll', queueDockedPreview, { passive: true });
      window.addEventListener('resize', queueDockedPreview, { passive: true });
      queueDockedPreview();
    }

    const maxChars = 20;

    /* =========================================================
       ENGRAVING PREVIEW
       ========================================================= */

    const input = section.querySelector('[data-engraving-input]');
    const preview = section.querySelector('[data-preview-text]');
    const mobilePreview = section.querySelector(
      '[data-mobile-preview-text]'
    );
    const count = section.querySelector('[data-char-count]');
    const fontOptions = section.querySelectorAll('[data-font-option]');
    const cards = section.querySelectorAll('.hbca-font-card');
    const cardPreviews = section.querySelectorAll(
      '[data-font-card-preview]'
    );

    const fontClassMap = {
      'imperial-script': 'hbca-font-imperial-script',
      'allura': 'hbca-font-allura',
      'libre-bodoni': 'hbca-font-libre-bodoni',
      'manrope-light': 'hbca-font-manrope-light',
      'prata': 'hbca-font-prata',
      'anton': 'hbca-font-anton'
    };

    const fontClasses = Object.values(fontClassMap);

    function updatePreviewText() {
      if (!input || !preview) return;

      input.value = input.value.slice(0, maxChars);

      const typedValue = input.value;
      const displayValue = typedValue.trim() || 'Your Name';

      preview.textContent = displayValue;

      if (mobilePreview) {
        mobilePreview.textContent = displayValue;
      }

      if (count) {
        count.textContent =
          typedValue.length + ' / ' + maxChars;
      }

      cardPreviews.forEach(function (cardPreview) {
        cardPreview.textContent = displayValue;
      });
    }

    function updateSelectedFont(option) {
      if (!option || !preview) return;

      const fontKey =
        option.getAttribute('data-font-option');

      const nextClass =
        fontClassMap[fontKey];

      fontClasses.forEach(function (className) {
        preview.classList.remove(className);

        if (mobilePreview) {
          mobilePreview.classList.remove(className);
        }
      });

      if (nextClass) {
        preview.classList.add(nextClass);

        if (mobilePreview) {
          mobilePreview.classList.add(nextClass);
        }
      }

      cards.forEach(function (card) {
        card.classList.remove('active');
      });

      const currentCard =
        option.closest('.hbca-font-card');

      if (currentCard) {
        currentCard.classList.add('active');
      }
    }

    if (input) {
      input.addEventListener(
        'input',
        updatePreviewText
      );
    }

    fontOptions.forEach(function (option) {
      option.addEventListener(
        'change',
        function () {
          updateSelectedFont(option);
          updatePreviewText();
        }
      );
    });

    const checkedFont =
      section.querySelector(
        '[data-font-option]:checked'
      );

    if (checkedFont) {
      updateSelectedFont(checkedFont);
    }

    updatePreviewText();


    /* =========================================================
       COMBINED SHOPIFY VARIANT LOGIC

       Shopify option values:

       Silver Comb w. Silver Fixed Clip
       Silver Comb w. Silver Swivel Clip
       Silver Comb w. Black Swivel Clip
       Silver Comb w. Black Fixed Clip

       Black Comb w. Silver Fixed Clip
       Black Comb w. Silver Swivel Clip
       Black Comb w. Black Swivel Clip
       Black Comb w. Black Fixed Clip
       ========================================================= */

    const variantDataElement =
      section.querySelector(
        '[data-hbca-variant-data]'
      );

    const variantIdInput =
      section.querySelector(
        '[data-hbca-variant-id]'
      );

    const combColorOptions =
      section.querySelectorAll(
        '[data-hbca-comb-color]'
      );

    const clipOptions =
      section.querySelectorAll(
        '[data-hbca-clip]'
      );

    const currentCombColor =
      section.querySelector(
        '[data-hbca-current-comb-color]'
      );

    const currentClip =
      section.querySelector(
        '[data-hbca-current-clip]'
      );

    const productPrice =
      section.querySelector(
        '[data-hbca-product-price]'
      );

    const addToCartButton =
      section.querySelector(
        '[data-hbca-add-to-cart]'
      );

    const addToCartLabel =
      section.querySelector(
        '[data-hbca-atc-label]'
      );

    const addToCartPrice =
      section.querySelector(
        '[data-hbca-atc-price]'
      );

    const previewImage =
      section.querySelector(
        '[data-hbca-preview-image]'
      );

    const mobileZoomSurface =
      section.querySelector(
        '[data-hbca-mobile-zoom-surface]'
      );

    const silverPreviewUrl =
      section.getAttribute(
        'data-silver-preview-url'
      ) || '';

    const blackPreviewUrl =
      section.getAttribute(
        'data-black-preview-url'
      ) || '';

    let variants = [];

    if (variantDataElement) {
      try {
        variants = JSON.parse(
          variantDataElement.textContent
        );
      } catch (error) {
        console.error(
          'HBCA engraving variant JSON error:',
          error
        );
      }
    }


    /* =========================================================
       GET SELECTED COMB COLOR
       ========================================================= */

    function getSelectedCombColor() {
      const checked =
        section.querySelector(
          '[data-hbca-comb-color]:checked'
        );

      return checked
        ? checked.value
        : 'Silver';
    }


    /* =========================================================
       GET SELECTED CLIP
       ========================================================= */

    function getSelectedClip() {
      const checked =
        section.querySelector(
          '[data-hbca-clip]:checked'
        );

      return checked
        ? checked.value
        : 'Silver Fixed Clip';
    }


    /* =========================================================
       CONVERT CUSTOM CONTROLS TO REAL SHOPIFY OPTION VALUE
       ========================================================= */

    function getCombinedOptionValue() {
      return (
        getSelectedCombColor() +
        ' Comb w. ' +
        getSelectedClip()
      );
    }


    /* =========================================================
       FIND THE REAL SHOPIFY VARIANT
       ========================================================= */

    function findSelectedVariant() {
      const combinedOptionValue =
        getCombinedOptionValue();

      return variants.find(
        function (variant) {
          return (
            variant.options &&
            variant.options[0] ===
              combinedOptionValue
          );
        }
      );
    }


    /* =========================================================
       UPDATE SELECTED CONTROL STYLES
       ========================================================= */

    function updateActiveControls() {
      combColorOptions.forEach(
        function (option) {
          const card =
            option.closest(
              '.hbca-color-swatch-card'
            );

          if (!card) return;

          card.classList.toggle(
            'active',
            option.checked
          );
        }
      );

      clipOptions.forEach(
        function (option) {
          const card =
            option.closest(
              '.hbca-variant-card'
            );

          if (!card) return;

          card.classList.toggle(
            'active',
            option.checked
          );
        }
      );

      if (currentCombColor) {
        currentCombColor.textContent =
          getSelectedCombColor();
      }

      if (currentClip) {
        currentClip.textContent =
          getSelectedClip();
      }
    }


    /* =========================================================
       CHANGE DESIGNER PREVIEW IMAGE + ENGRAVING COLOR

       IMPORTANT:
       Shopify Media #1 = lifestyle thumbnail
       Shopify Media #2 = silver designer preview
       Shopify Media #3 = black designer preview

       The featured product thumbnail does NOT control
       the engraving designer.
       ========================================================= */

    function updateCombPresentation() {
      const isBlack =
        getSelectedCombColor() === 'Black';

      section.classList.toggle(
        'hbca-comb-black',
        isBlack
      );

      const nextPreviewUrl =
        isBlack
          ? blackPreviewUrl
          : silverPreviewUrl;

      if (
        previewImage &&
        nextPreviewUrl
      ) {
        previewImage.src =
          nextPreviewUrl;

        previewImage.alt =
          isBlack
            ? 'Black custom engraved comb preview'
            : 'Silver custom engraved comb preview';
      }

      if (
        mobileZoomSurface &&
        nextPreviewUrl
      ) {
        mobileZoomSurface.style.backgroundImage =
          'url("' +
          nextPreviewUrl +
          '")';
      }
    }


    /* =========================================================
       CHECK IF COMB + CLIP COMBINATION EXISTS
       ========================================================= */

    function combinationExists(
      color,
      clip
    ) {
      const combined =
        color +
        ' Comb w. ' +
        clip;

      return variants.some(
        function (variant) {
          return (
            variant.options &&
            variant.options[0] ===
              combined
          );
        }
      );
    }


    /* =========================================================
       UPDATE SWATCH / CLIP AVAILABILITY
       ========================================================= */

    function colorHasVariants(color) {
      return Array.from(clipOptions).some(function (clip) {
        return combinationExists(color, clip.value);
      });
    }

    // When switching colors, keep the current clip if possible;
    // otherwise select the first existing Shopify combination.
    function ensureValidSelection() {
      let color = getSelectedCombColor();
      if (!colorHasVariants(color)) {
        const firstColor = Array.from(combColorOptions).find(function (option) {
          return colorHasVariants(option.value);
        });
        if (firstColor) {
          firstColor.checked = true;
          color = firstColor.value;
        }
      }

      const selectedClip = getSelectedClip();
      if (!combinationExists(color, selectedClip)) {
        const firstClip = Array.from(clipOptions).find(function (option) {
          return combinationExists(color, option.value);
        });
        clipOptions.forEach(function (option) {
          option.checked = !!firstClip && option === firstClip;
        });
      }
    }

    function updateControlAvailability() {
      const selectedColor = getSelectedCombColor();

      // Color availability depends on ANY clip for that color, not
      // on the clip previously selected for the other color.
      combColorOptions.forEach(function (option) {
        const card = option.closest('.hbca-color-swatch-card');
        const exists = colorHasVariants(option.value);
        if (card) card.classList.toggle('is-unavailable', !exists);
        option.disabled = !exists;
      });

      clipOptions.forEach(function (option) {
        const card = option.closest('.hbca-variant-card');
        const exists = combinationExists(selectedColor, option.value);
        if (card) {
          card.hidden = !exists;
          card.style.display = exists ? '' : 'none';
          card.classList.remove('is-unavailable');
          card.setAttribute('aria-hidden', String(!exists));
        }
        option.disabled = !exists;
        if (!exists) option.checked = false;
      });
    }


    /* =========================================================
       UPDATE REAL PRODUCT VARIANT
       ========================================================= */

    function updateProductVariant() {
      ensureValidSelection();
      updateActiveControls();

      updateCombPresentation();

      updateControlAvailability();

      const variant =
        findSelectedVariant();


      /* -------------------------------------------------------
         NO MATCHING VARIANT
         ------------------------------------------------------- */

      if (!variant) {
        if (variantIdInput) {
          variantIdInput.value = '';
        }

        if (addToCartButton) {
          addToCartButton.disabled =
            true;
        }

        if (addToCartLabel) {
          addToCartLabel.textContent =
            'Unavailable';
        }

        if (addToCartPrice) {
          addToCartPrice.hidden =
            true;
        }

        return;
      }


      /* -------------------------------------------------------
         UPDATE ACTUAL SHOPIFY VARIANT ID
         ------------------------------------------------------- */

      if (variantIdInput) {
        variantIdInput.value =
          variant.id;
      }


      /* -------------------------------------------------------
         UPDATE TOP PRODUCT PRICE

         Silver variants = whatever Shopify says
         Black variants = whatever Shopify says

         Nothing is hard-coded here.
         ------------------------------------------------------- */

      if (productPrice) {
        productPrice.textContent =
          variant.priceFormatted;
      }


      /* -------------------------------------------------------
         UPDATE ADD TO CART PRICE
         ------------------------------------------------------- */

      if (addToCartPrice) {
        addToCartPrice.textContent =
          '· ' +
          variant.priceFormatted;
      }


      /* -------------------------------------------------------
         AVAILABLE VARIANT
         ------------------------------------------------------- */

      if (variant.available) {
        if (addToCartButton) {
          addToCartButton.disabled =
            false;
        }

        if (addToCartLabel) {
          addToCartLabel.textContent =
            'Add to Cart';
        }

        if (addToCartPrice) {
          addToCartPrice.hidden =
            false;
        }
      }


      /* -------------------------------------------------------
         SOLD OUT VARIANT

         Price stays visible so the customer can still
         see that Black is $98 even if inventory is 0.
         ------------------------------------------------------- */

      else {
        if (addToCartButton) {
          addToCartButton.disabled =
            true;
        }

        if (addToCartLabel) {
          addToCartLabel.textContent =
            'Sold Out';
        }

        if (addToCartPrice) {
          addToCartPrice.hidden =
            false;
        }
      }


      /* -------------------------------------------------------
         UPDATE ?variant= IN URL

         This does NOT change the product thumbnail.
         It only reflects the actual selected Shopify variant.
         ------------------------------------------------------- */

      if (
        window.history &&
        window.history.replaceState
      ) {
        const url =
          new URL(
            window.location.href
          );

        url.searchParams.set(
          'variant',
          variant.id
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      }
    }


    /* =========================================================
       COMB COLOR EVENTS
       ========================================================= */

    combColorOptions.forEach(
      function (option) {
        option.addEventListener(
          'change',
          function () {
            updateProductVariant();
          }
        );
      }
    );


    /* =========================================================
       CLIP EVENTS
       ========================================================= */

    clipOptions.forEach(
      function (option) {
        option.addEventListener(
          'change',
          function () {
            updateProductVariant();
          }
        );
      }
    );


    /* =========================================================
       INITIALIZE
       ========================================================= */

    if (variants.length) {
      updateProductVariant();
    }
  });
});